import * as React from "react";
import { useHistory } from "react-router-dom";
import { URLS } from "@/utils/routes";
import { PROMPT_STUDIO_TABS, PromptStudioHeader } from "./PromptStudioHeader";

export type CoachPromptStudioTab = "designs" | "backgrounds";

const TAB_URLS: Record<CoachPromptStudioTab, string> = {
  designs: URLS.coach.promptStudio,
  backgrounds: URLS.coach.promptStudioBackgrounds,
};

interface CoachPromptStudioHeaderProps {
  tab: CoachPromptStudioTab;
  actions?: React.ReactNode;
}

/** The coach's Prompt Studio list header: ‹ Library │ Prompt Studio │ Designs · Backgrounds. */
export const CoachPromptStudioHeader: React.FC<CoachPromptStudioHeaderProps> = ({ tab, actions }) => {
  const history = useHistory();

  return (
    <PromptStudioHeader
      backTo={URLS.coach.prompts}
      backLabel="Library"
      tabs={PROMPT_STUDIO_TABS}
      selectedTab={tab}
      onTabChange={key => key !== tab && history.push(TAB_URLS[key as CoachPromptStudioTab])}
      actions={actions}
    >
      <div className="text-xl leading-7 font-bold text-slate-800">Prompt Studio</div>
    </PromptStudioHeader>
  );
};
